import { sendRequest } from "../api"

const getDefaultState = () => {
    return {
        list: [],
        list_loading: false,
    }
}
// REVIEW
export default ({
    namespaced: true, //
    // variable
    state: getDefaultState(),
    // must syncronous
    mutations: {
        RESET_STATE(state) {
            // Merge rather than replace so we don't lose observers
            // https://github.com/vuejs/vuex/issues/1118
            Object.assign(state, getDefaultState())
        },
        ADD_TO_LIST(state, payload) {
            state.list.unshift(payload)
        },
        SET_LIST(state, payload) {
            state.list = payload
        },
        SET_LIST_LOADING(state, payload) {
            state.list_loading = payload
        }

    },
    // can async
    actions: {
        loadList({commit}) {
            commit('SET_LIST_LOADING', true)
            return sendRequest('stock-transfer', {}, 'get', (successResponse) => commit('SET_LIST', successResponse), () => {}, () => commit('SET_LIST_LOADING', false))
        }
    },
    // call variable with custom display
    getters: {

    },
    // modules
    modules: {

    }
})
